<template>
    <header class="coverWrapper">
        <TransitionEffect
            name="simpleFade"
            :appear="true">
            <BlurredBackground
                :image="cover"/>
        </TransitionEffect>
        <div class="cover">
            <img class="coverImage"
                alt="Cover image"
                :src="cover">
            <div class="coverContent">
                <template
                    v-if="permissions.isAdmin || permissions.isWriter && isEditing">
                    <input class="fileUploadOriginal"
                        accept="image/jpeg"
                        type="file"
                        name="file"
                        id="file"
                        tabindex="-1"
                        @change="uploadFile"/>
                   
                        <Button v-if="!payload"
                            appearance="secondary"
                            size="small"
                            prefixIcon="edit">
                            <label class="uploadLabel"
                                for="file"
                                tabindex="0">
                                {{ siteContent.newCover }}
                            </label>
                        </Button>

                        <Button v-else-if="!isCoverUpdated"
                            appearance="primary"
                            size="small"
                            prefixIcon="save"
                            @click="changeCover">
                            {{ siteContent.update }}
                        </Button>
                </template>
            </div>
        </div>
    </header>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Cover',
        props: {
            currentPost: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                required: true
            },
            isEditing: {
                type: Boolean,
                required: true
            },
            id: {
                type: String,
                required: true
            }
        },
        computed: {
            cover() {
                if(!this.payload) {
                    return this.currentPost.cover
                } else {
                    return this.preview
                }
            }
        },
        data() {
            return {
                payload: null,
                preview: '',
                isCoverUpdated: false,
            }
        },
        methods: {
            ...mapActions('blog',['updateCover','uploadFileToStore']),

            async uploadFile(e) {
                var files = e.target.files || e.dataTransfer.files
                var fileSize = e.target.files[0].size / 1024 / 1024 // size in MB

                if (fileSize > 0.4) {
                    this.$toasted.show(this.siteContent.keepFilesUnderLimit)
                    return
                } else if (!files.length) {
                    return
                } else {
                    await this.createPreview(files[0])
                    var currentTime = new Date().getTime()
                    var file = files[0]
                    var filePath = 'users/' + this.auth.id + '/posts/' + currentTime.toString() + '/' + file.name.replace(/\.[^/.]+$/, "")  + '.jpg'
                    
                    this.payload = {
                        file: file,
                        filePath: filePath
                    }

                    console.log(this.payload)
                    this.isCoverUpdated = false
                }
            },
            createPreview(file) {
                var reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = (e) => {
                    var image = e.target.result
                    this.preview = image
                }
            },
            async changeCover() {
                try {
                    var cover = await this.uploadFileToStore(this.payload)

                    var updatedCover = {
                        cover: cover
                    }

                    var oldCover = this.currentPost.cover
                    var postId = this.id

                    await this.updateCover({ postId, updatedCover, oldCover })
                    this.$toasted.show(this.siteContent.coverUpdateSuccess)

                    this.isCoverUpdated = true
                } catch(err) {
                    console.log(err)
                    this.$toasted.show(this.siteContent.coverUpdateError)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../../scss/variables';

    .fileUploadOriginal {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }

    .coverWrapper {
        display: flex;
        justify-content: center;
        padding: 2rem 1rem 1rem 1rem;
        width: 100%;
    }
    
    .cover {
        position: relative;
        height: 28rem;
        max-width: 72rem;
        width: 100%;
    }

    .coverImage {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: block;
        object-fit: cover;
        background: var(--color-grey-200);
        border-radius: 1rem;
    }

    .coverContent {
        max-width: 72rem;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 1rem;
        position: relative;
    }

    .h1 {
        margin: 0;
        color: var(--color-white-important);
    }

    @media all and (max-width: 1024px) {
        .coverWrapper {
            padding: 0;
        }

        .coverContent {
            padding: 1rem;
        }

        .cover {
            height: 24rem;
        }

        .coverImage {
            border-radius: 0 0 1rem 1rem;
        }
    }

    @media all and (max-width: 640px) {
        .cover {
            height: 16rem;
        }
    }
</style>